import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { useLang } from "../../lib/i18n";
import { useAuth } from "../../lib/auth";
import { AssistantChat } from "./AssistantChat";
import { useAiCtx } from "./aiContext";

export function AssistantFab() {
  const { t } = useLang();
  const { can, isStaff } = useAuth();
  const { pathname } = useLocation();
  const ctx = useAiCtx();
  const [open, setOpen] = useState(false);
  if (!isStaff || !can("ai_assistant") || pathname.startsWith("/assistant")) return null;
  const where = ctx.project_id ? t("this project", "este proyecto") : ctx.customer_id ? t("this customer", "este cliente") : "";
  const examples = ctx.project_id ? [t("Make the contract", "Hazme el contrato"), t("Create a change order: painting the doors for $800", "Crea un change order: pintura de puertas por $800"), t("Create the deposit invoice", "Haz la factura del depósito"), t("Write a message for the customer", "Escribe un mensaje para el cliente")]
    : ctx.customer_id ? [t("Create an estimate for this customer", "Créame un estimado para este cliente"), t("Summarize this customer", "Resume este cliente"), t("Write a follow-up message", "Escribe un mensaje de seguimiento")]
      : [t("Show my appointments tomorrow", "Muestra mis citas de mañana"), t("Which projects need attention?", "¿Qué proyectos requieren atención?")];
  return (
    <>
      <button className="fixed right-4 bottom-24 lg:bottom-6 z-40 w-14 h-14 rounded-full bg-[#D9531E] text-white shadow-lg grid place-items-center hover:scale-105 transition-transform" onClick={() => setOpen(true)} aria-label={t("AI Assistant", "Asistente IA")} data-testid="assistant-fab"><Sparkles className="w-6 h-6" /></button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-md p-3 flex flex-col" data-testid="assistant-panel">
          <SheetHeader><SheetTitle className="flex items-center gap-2"><Sparkles className="w-5 h-5 text-[#D9531E]" /> {t("AI Assistant", "Asistente IA")}{where && <span className="text-xs font-semibold text-slate-500">· {where}</span>}</SheetTitle></SheetHeader>
          <div className="flex-1 min-h-0 mt-2"><AssistantChat ctx={ctx} compact examples={examples} onNav={() => setOpen(false)} /></div>
        </SheetContent>
      </Sheet>
    </>
  );
}
